<template>
<v-card>
    <v-toolbar card dense color="transparent">
        <v-toolbar-title>
            <h4>
                <!-- <v-icon light>menu</v-icon> -->
                <v-icon light>local_shipping</v-icon>Latest Trucks
            </h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
            <v-icon class="morehoriz">more_horiz</v-icon>
        </v-btn>
    </v-toolbar>
    <p class="sub_txt">Here are your latest truck matches</p>
    <v-divider></v-divider>
    <v-card-text class="pa-0 mh195">
        <v-data-table :items="loads" hide-actions hide-headers class="table-striped dashtable">
            <tr slot="items" slot-scope="props" class="post-row" @click="goToPost(props.item.uuid)">
                <td>
                    <v-chip label small color="orange" text-color="white">{{ _getDateDiff(props.item.created_date) }}</v-chip>
                </td>
                
                <td class="text-xs-left"><strong>{{ props.item.origin }} </strong></td>
                <td class="text-xs-left">to<td>
                <td class="text-xs-left"> <strong>{{ props.item.dest }}  </strong></td>
                
            </tr>
        </v-data-table>
        
        <v-divider></v-divider>
        <div class="divMore">
            <router-link class="more-btn" :to="{name: 'SearchTrucks'}">
                More
            </router-link>
        </div>
    </v-card-text>
</v-card>
</template>

<script>
import moment from 'moment';
import services from "../../../services/HttpService";
import utils from '../../../util/';
export default {
    mounted() {
        this.getTrucks();
    },
    created() {
        this.utils = utils;
    },
    data() {
        return {
            loads: [],
            currDate: new Date(),
            utils: null
        }

    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        goToPost(data) {
            this.$router.push("/trucks/detail/" + data);
        },
        _getDateDiff(date) {
            let diff = Math.floor(utils.dateDiff(this.currDate, date, 's') / 60),
                h = Math.floor(diff / 60),
                m = diff % 60;
            if (m < 0) {
                m = 0;
            }
            if (h < 0) {
                h = 0;
            }
            if (h <= 0) {
                return m + 'm';
            } else if (h > 8) {
                return '8h+'
            } else {
                return h + 'h' + ' ' + m + 'm'
            }
        },
        getTrucks() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            services
                .get(
                    "trucks/list", {
                        Authorization: "Bearer " + this.$store.state.user.token
                    }, {
                        show_all: true,
                        limit: '3'
                    }
                )
                .then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if (res.status === 200) {
                        self.loads = res.data.data.filter((dt, i) => {
                            
                            dt.origin = dt.origin_city + ', ' + dt.origin_state;
                            dt.dest = dt.dest_city + ', ' + dt.dest_state;
                            dt.ind = i;
                            return dt;
                        });
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, "red");
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/widgets/dashboard/MyTrucks.vue